import { useContext } from 'react'
import { DesignContext } from 'contexts/DesignContext'
import objectPath from 'object-path'
import { Button, Modal, Row, Col } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react'
import { useHistory } from 'react-router-dom'

const ModalSuccessNoti = () => {
  const history = useHistory()
  const designContext = useContext(DesignContext)
  const { isUiChanged, setIsUiChanged, jsonForm = {}, urlParams = {} } =
    designContext
  const isOpenModal = objectPath.get(isUiChanged, ['successModal', 'isOpen'])

  const closeModal = () => {
    objectPath.set(isUiChanged, ['successModal', 'isOpen'], false)
    setIsUiChanged(isUiChanged)
  }

  const reload = () => {
    window.location.reload()
  }

  const getParamValue = ({ propType, key, value, sourceKey }) => {
    let formData = objectPath.get(jsonForm, 'formData') || {}
    let datasourceValue = objectPath.get(designContext, '@datasource') || {}

    if (propType === 'datasource') {
      return sourceKey && key
        ? objectPath.get(datasourceValue, `${sourceKey}.${key}`)
        : objectPath.get(datasourceValue, key)
    }
    if (propType === 'urlParam') {
      return objectPath.get(urlParams, key)
    }
    if (['input', 'formData', 'table'].includes(propType)) {
      return objectPath.get(formData, key)
    }
    return value
  }

  const goBack = () => {
    let modalAction = objectPath.get(isUiChanged, [
      'successModal',
      'modalAction',
    ])
    if (!modalAction) return
    let {
      formCode,
      sourceType,
      perspectiveRoute = '',
      pathParams = [],
      queryParams = [],
    } = modalAction
    if (!sourceType || !formCode) return
    let path = `/display/${sourceType}/${formCode}`
    pathParams.forEach((paramData) => {
      let paramValue = getParamValue(paramData)
      if (paramValue === null || paramValue === undefined || paramValue === '') {
        return
      }
      if (path.includes(`:${paramData.param}`)) {
        path = path.replace(`:${paramData.param}`, paramValue)
      } else {
        path = `${path}/${paramValue}`
      }
    })
    if (perspectiveRoute.startsWith('/#')) {
      perspectiveRoute = perspectiveRoute.replace('/#', '')
      path = `${perspectiveRoute}${path}`
    } else if (perspectiveRoute.startsWith('/')) {
      path = `${perspectiveRoute}${path}`
    } else if (perspectiveRoute) {
      path = `/${perspectiveRoute}${path}`
    } else {
      path = `/designer${path}`
    }
    let queryString = []
    queryParams.forEach((paramData) => {
      let paramValue = getParamValue(paramData)
      if (paramValue !== null && paramValue !== undefined) {
        queryString.push(`${paramData.param}=${paramValue}`)
      }
    })
    let historyData = {
      pathname: path,
      search: queryString.length > 0 ? `?${queryString.join('&')}` : '',
      state: null,
    }
    history.push(historyData)
    closeModal()
  }

  if (isOpenModal) {
    return (
      <Modal show={isOpenModal} size="md">
        <Modal.Header onHide={closeModal}>
          <h5
            className="mb-0"
            style={{
              color: '#000',
            }}
          >
            แจ้งเตือน
          </h5>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Row>
            <Col sm="12">
              <h3 className="text-success text-center">บันทึกสำเร็จ</h3>
            </Col>
            <Col sm="12" className="mt-4 d-flex justify-content-center">
              <Button className="mx-1" onClick={reload}>
                <FeatherIcon icon="log-out" size="14" className="mr-1" />
                กลับไปหน้าข้อมูล
              </Button>
              <Button
                className="mx-1"
                variant="outline-secondary"
                onClick={goBack}
              >
                <FeatherIcon icon="log-out" size="14" className="mr-1" />
                กลับไปหน้าตาราง
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    )
  }
  return <></>
}

export default ModalSuccessNoti
